import * as React from 'react';
import { Link } from 'gatsby';
// import '@fontsource/inter';
import { Helmet } from 'react-helmet';
import '../styles/index.css';

const Layout = ({ location, title = 'Matomo Packages', children }) => {
  const rootPath = `${__PATH_PREFIX__}/`;
  const isRootPath = location.pathname === rootPath;

  return (
    <div data-is-root-path={isRootPath}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{title}</title>
        <link rel="canonical" href={location.href} />
      </Helmet>
      <header>
        <nav>
          <div>
            <Link className="header-link-home" to="/">
              Matomo Packages
            </Link>
            <Link
              partiallyActive={true}
              activeClassName="active"
              to="/plugins/"
            >{`Plugins`}</Link>
            <Link
              partiallyActive={true}
              activeClassName="active"
              to="/themes/"
            >{`Themes`}</Link>
            <Link
              activeClassName="active"
              to="/premium-plugins/"
            >{`Premium plugins`}</Link>
            <Link
              activeClassName="active"
              to="/premium-bundles/"
            >{`Bundles`}</Link>
            <Link
              activeClassName="active"
              to="/geo-data/"
            >{`Geo IP Databases`}</Link>
          </div>
        </nav>
        {/* <h1>{title}</h1> */}
      </header>
      <main>{children}</main>

      <footer>
        <div>
          {!isRootPath && (
            <Link className="header-link-home" to="/">
              Matomo Packages
            </Link>
          )}
          <Link
            partiallyActive={true}
            activeClassName="active"
            to="/toplist/"
          >{`Toplists`}</Link>
          <Link
            partiallyActive={true}
            activeClassName="active"
            to="/new/"
          >{`New plugins & themes`}</Link>{' '}
          <Link
            partiallyActive={true}
            activeClassName="active"
            to="/updates/"
          >{`Updates`}</Link>
        </div>
      </footer>
      {/* 
      <footer>
        © {new Date().getFullYear()}, Built by
        {` `}
        <a href="https://whitespace.se/">Whitespace</a>.
      </footer> */}
    </div>
  );
};

export default Layout;
